import { Helmet } from '@dr.pogodin/react-helmet';
import { format } from 'date-fns';
import { useParams } from 'react-router';
import NoticeSiteHasBeenArchived from '../common/lib/NoticeSiteHasBeenArchived';
import PageNotFound from '../common/lib/PageNotFound';
import XoopsCode from '../common/lib/XoopsCode';
import type { MultiLang } from '../config';
import Functions from '../functions';
import CreditsUtils from './lib/CreditsUtils';

interface Props {
    lang: MultiLang;
}

const CreditsPage = (props: Props) => {
    const { lang } = props;
    const { id } = useParams<{ id: string }>();
    if (!id) {
        return <PageNotFound lang={lang} />;
    }
    const pageId = parseInt(id, 10);
    const page = CreditsUtils.getPage(pageId);
    if (page === null) {
        return <PageNotFound lang={lang} />;
    }
    const title = Functions.mlang(page.title, lang);
    return (
        <>
            <Helmet>
                <title>
                    {title} - {Functions.siteTitle(lang)}
                </title>
            </Helmet>
            <h3>{title}</h3>
            <NoticeSiteHasBeenArchived lang={lang} />
            <div style={{ textAlign: 'right' }}>
                {Functions.mlang('[en]Last Update[/en][ja]最終更新日[/ja]', lang)} :{' '}
                {format(new Date(page.lastupdate * 1000), 'MMMM do, yyyy')}
            </div>
            <hr />
            <XoopsCode lang={lang} text={page.content} dohtml={true} />
        </>
    );
};

export default CreditsPage;
